import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Seo from './Seo';
import ProductSidebar from './ProductSidebar';
import { useUser, studioThemeClass } from '../contexts/UserContext';
import ATSCheckStudio from './ATSCheckStudio';

// Standalone ATS Studio — the scanner on its own full page, reached from the
// "Run my ATS scan" CTA on /ATSCheck. Same shell idiom as /resume-studio:
// the landing page sells, the studio works.
const ATSStudioPage = () => {
  const navigate = useNavigate();
  // Theme lives in UserContext so every studio shares one switch.
  const { user, studioTheme } = useUser();

  // Auth modal lives on the homepage; route there with a flag when needed.
  const setShowAuthModal = useCallback((show) => {
    if (show) navigate('/?openLogin=1');
  }, [navigate]);

  return (
    <div className={`acs-page cls-page ${studioThemeClass(studioTheme)}`}>
      <Seo
        title="ATS Studio — Scan Your Resume Against Any Job"
        description="Paste a job description, drop in your resume, and get an ATS match score with every missing keyword and format fix — in one distraction-free workspace."
        path="/ats-studio"
      />
      <Header setShowAuthModal={setShowAuthModal} />
      <ProductSidebar user={user} setShowAuthModal={setShowAuthModal} />

      <ATSCheckStudio setShowAuthModal={setShowAuthModal} />
    </div>
  );
};

export default ATSStudioPage;
